// -----------------------------------------------
// SNS
// -----------------------------------------------
$(function() {
  var $librarySnsBtn = $('#js-library-sns-btn'),
      $ibrarySnsList = $('#js-ibrary-sns-list');

  $librarySnsBtn.on('click', function() {
    if($(this).hasClass('is-show')) {
      $(this).removeClass('is-show');
      $ibrarySnsList.fadeOut();
    } else {
      $(this).addClass('is-show');
      $ibrarySnsList.fadeIn();
    }
  });
});

$(function() {
  var headerHight = 62;
  // #で始まるアンカーをクリックした場合に処理(.non_scrollをつけると除外)
  $('a[href^=#]' + 'a:not(.non_scroll)').click(function() {
    // スクロールの速度
    var speed = 400; // ミリ秒
    // アンカーの値取得
    var href= $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top - headerHight; // ※　-headerHightでズレの処理
    // スムーズスクロール
    $('body,html').animate({scrollTop:position}, speed, 'swing');

    return false;
  });
});

/* ==========================================================================
   tile処理まとめ
   ==========================================================================*/
$(function() {
  $('.js-tile_title').tile(2);
  $('.js-tile_table').tile(2);
  $('.js-tile-cast').tile(2);
  $('.js-tile-recommend').tile(2);
});

/* ==========================================================================
   スライダーのタイトルの長い文字処理
   ==========================================================================*/
(function(){
  var $setElm = $('.js-cut_txt'),
      afterTxt = ' …'; // 文字カット後に三点リーダーに置き換え
  $setElm.each(function(){
    var cutFigure = $(this).data('text-count'),
        textLength = $(this).text().length,
        textTrim = $(this).text().substr(0,(cutFigure));
    if(cutFigure < textLength) {
      $(this).html(textTrim + afterTxt).css({visibility:'visible'});
    } else if(cutFigure >= textLength) {
      $(this).css({visibility:'visible'});
    }
  });
}());

/* --------------------------------------
	今見るならこれ！当サイトおすすめ作品TOP20
---------------------------------------*/
$(function(){
	$('.situation_cnt').each(function(){
		var itemHeight = $(this).children('.brand_tag').height();
		$(this).find('.situation_cnt_inner').css('padding-bottom',itemHeight + 3);

		$(this).find('.brand_tag').hover(function(){
			$(this).prev().addClass('on');
		},
		function () {
			$(this).prev().removeClass('on');
		});
	});
	$('.situation_cnt:last').css('border-bottom', 'none');
});

/* ==========================================================================
   ツールチップ
   ==========================================================================*/
$(function(){
	$(document).on({
	"mouseenter": function(){
		$(this).find('.tooltip').stop().fadeIn();
	},
	"mouseleave": function(){
		$(this).find('.tooltip').stop().fadeOut();
	}
	}, "th.situation,td.bnr_library");
});

/* ==========================================================================
   vod_contentの4の倍数はmargin-rightをなくす(段落ち防止)
   ==========================================================================*/
$(document).ajaxComplete(function(){
	$('.vod_content:nth-child(4n)').css({
		marginRight: '0px',
	});
});

/* ==========================================================================
   タイル
   ==========================================================================*/
var recommendList  = '.js-recommend-list',
    $recommendList = $(recommendList);
$recommendList.tile();


/* ==========================================================================
   href属性で遷移させられない場合にjsで遷移させる
   ==========================================================================*/
$(function(){
  var libraryModuleLink = '.js-library_module_link',
    $libraryModuleLink = $(libraryModuleLink),
    linkAction = '.js-link_action',
    $linkAction = $(linkAction),
    hostname = new RegExp(location.hostname); // あとで文字列の一致に使用するため正規表現クラスのインスタンスとして保存

  $libraryModuleLink.on('click', function(e) {
    var libraryModuleLinkData = $(this).data('library-link');
    var target = $(e.target);

    if (!target.is(linkAction)) {
      // とばしたいリンクがドメイン内なら内部遷移、外部リンクなら別タブで表示
      if (hostname.test(libraryModuleLinkData)) {
        location.href = libraryModuleLinkData;
      } else {
        window.open(libraryModuleLinkData, '_blank');
      }
    }

  });
});

// Fixed Cv Btn
// $(function() {
//   var $fixedCvr = $('.js-fixed_cvr'),
//       fixedCvrHeight = $fixedCvr.innerHeight(),
//       $target = $('.js-hide_btn_target');

//   $target.on('inview', function(e, isInView) {
//     if(isInView) {
//       $fixedCvr.css({bottom: '-' + fixedCvrHeight + 'px'});
//     } else {
//       $fixedCvr.css({bottom: '0'});
//     }
//   });
// });

$(function() {
  var $chartObjList = $('.js-brand-point-score-chart');
  if($chartObjList.length) {    
    $chartObjList.each(function(index, chartObj) {
      var canvas = chartObj.getContext("2d");
      var $chartObj = $(chartObj);
      var chartLabels = $chartObj.data('chart-labels');
      var chartDatas = $chartObj.data('chart-datas');
      var chartObjHeight = $chartObj.closest('div').height

      new Chart(canvas, {
        type: 'radar',
        data: {
          labels: chartLabels,
          datasets: [{
            data: chartDatas,
            borderColor: '#757de0',
            backgroundColor: [
              'rgba(229, 231, 250, 0.6)',
            ],
            lineTension: 0.2,
          }],
        },
        options: {
          layout: {
          },
          // 親要素いっぱいに表示
          maintainAspectRatio: false,
          scale: {
            ticks: {
              display: false,
              max: 5,
              min: 0,
              stepSize: 1,
              scaleLabel: {
                display: false,
              },
            },
            pointLabels: {
              fontColor: '#757de0',
              fontSize: 10,
              fontStyle: 'bold',
            },
            angleLines: {
              color: '#e5e7fa',
              borderDash: [8, 8]
            },
            gridLines: {
              circular: true,
              // color: '#e5e7fa',
              color: [
                'rgba(229, 231, 250, 0.2)',
                'rgba(229, 231, 250, 0.4)',
                'rgba(229, 231, 250, 0.6)',
                'rgba(229, 231, 250, 0.8)',
                'rgba(229, 231, 250, 1)',
              ],
              lineWidth: 2,
            },
          },
          legend: {
            display: false,
            labels: {
              fontSize: 10,
              fontStyle: 'bold',
              fontColor: '#757de0',
            },
          }
        }
      });
    });
  }
});